import { useHeroVorgang } from "@/lib/heroVorgang"
import { VORGANG_OHNE_NAME, vorgangBezeichnung } from "@/lib/vorgangName"

/**
 * Zeigt die HERO-Bezeichnung eines verknuepften Vorgangs — nie die Nummer.
 *
 * Reihenfolge:
 *  1. `bekannt` — eine fertige Bezeichnung, die der Aufrufer schon hat.
 *  2. `nr`/`titel` aus dem lokalen Projekt-Cache (Listen liefern sie mit).
 *  3. Sonst EIN Lookup ueber /api/v1/hero/lookup (gleicher Cache-Schluessel
 *     wie das Kalender-Fenster, wird also geteilt).
 *  4. Waehrend des Ladens und bei jedem Fehler: die neutrale Beschriftung —
 *     „Vorgang in HERO", nicht „Projekt #8700484".
 *
 * Rendert nur Text; Link, Popover und Icon setzt der Aufrufer drumherum.
 */
export function HeroVorgangName({
  tenantSlug, projectId, nr, titel, bekannt, fallback = VORGANG_OHNE_NAME,
}: {
  tenantSlug: string | null | undefined
  projectId: number | string | null | undefined
  nr?: string | null
  titel?: string | null
  bekannt?: string | null
  fallback?: string
}) {
  const vorab = (bekannt || "").trim() || vorgangBezeichnung(nr, titel)
  const treffer = useHeroVorgang(tenantSlug, projectId, !vorab)
  if (vorab) return <>{vorab}</>
  const name = (treffer?.name || "").trim()
  return <>{name || fallback}</>
}
